import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Icon } from '@mui/material';
import { IconComponent } from "Components/IconComponent";
import DefaultReportMenu from "./DefaultReportMenu";

export const ReportMenu = () => {
  const user = useSelector((state) => state.auth);

  const MenuCard = ({ menu }) => {
    const [open, setOpen] = React.useState(false);
    return (
      <div>
        {menu.reportLevelOneNavigations.length === 0 ? (
          <NavLink to={menu.path} activeClassName="active-nav" exact>
            <ListItem button>
              <IconComponent iconName={menu.icon} props={menu.props} />
              <ListItemText primary={menu.label} />
            </ListItem>
          </NavLink>
        ) : (
          <><div onClick={() => setOpen(!open)}>
            <ListItem button>
              <IconComponent iconName={menu.icon} props={menu.props} />

              <ListItemText primary={menu.label} />
              {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
            </ListItem>
          </div>
            <Collapse component="li" in={open} timeout="auto" unmountOnExit>
              <LevelOneNavigations reportLevelOneNavigations={menu.reportLevelOneNavigations} />
            </Collapse>

          </>
        )}
      </div>
    );
  };

  const LevelOneNavigations = ({ reportLevelOneNavigations }) => {
    const [open, setOpen] = React.useState(false);
    return (
      <div>
        {reportLevelOneNavigations.map((levelOneNavigation, index) => (
          levelOneNavigation.levelTwoNavigations === undefined || levelOneNavigation.levelTwoNavigations.length === 0 ? (
            <NavLink to={levelOneNavigation.path} activeClassName="active-nav" exact>
              <ListItem button>
                <IconComponent iconName={levelOneNavigation.icon} props={levelOneNavigation.props} />
                <ListItemText primary={levelOneNavigation.label} />
              </ListItem>
            </NavLink>
          ) : (
            <React.Fragment><div onClick={() => setOpen(!open)}>
              <ListItem button>
                <IconComponent iconName={levelOneNavigation.icon} props={levelOneNavigation.props} />
                <ListItemText primary={levelOneNavigation.label} />
                {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
              </ListItem>
            </div>
              <Collapse component="li" in={open} timeout="auto" unmountOnExit>
                <LevelTwoNavigations levelTwoNavigations={levelOneNavigation.levelTwoNavigations} />
              </Collapse>
            </React.Fragment>
          )
        ))}

      </div>
    );
  };
  const LevelTwoNavigations = ({ levelTwoNavigations }) => {
    const [open, setOpen] = React.useState(false);
    return (
      <div>
        {levelTwoNavigations.map((levelTwoNavigation, index) => (
          <NavLink to={levelTwoNavigation.path} activeClassName="active-nav" exact>
            <ListItem button>
              <IconComponent iconName={levelTwoNavigation.icon} props={levelTwoNavigation.props} />
              <ListItemText primary={levelTwoNavigation.label} />
            </ListItem>
          </NavLink>

        ))}
      </div>
    );
  };

  return (
    <>
      <DefaultReportMenu MenuCard={MenuCard} />
    </>
  );
};

export const SubListItems = () => {
  const ChildrenListItems = ({ menu }) => {
    const [open, setOpen] = React.useState(false);
    return (
      <>
        <div
          onClick={() => {
            setOpen(!open);
          }}
        >
          <ListItem button>
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.label} />
            {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
          </ListItem>
        </div>
        <Collapse component="li" in={open} timeout="auto" unmountOnExit>
          {menu.children.map((children, index) => (
            <NavLink
              key={index}
              to={children.path}
              activeClassName="active-nav"
              exact
              onClick={() => {
                setOpen(!open);
              }}
            >
              <ListItem button style={{ paddingLeft: 30 }}>
                <ListItemIcon>{children.icon}</ListItemIcon>
                <ListItemText primary={children.label} />
              </ListItem>
            </NavLink>
          ))}
        </Collapse>
      </>
    );
  };

};